// Slim timeline-feed model helpers — mirrors the Flutter app's
// timeline_slim_models.dart (TimelinePlayerRef / TimelineTeam). The slim feed
// teams carry only `players[]` (no name/initials/team image), so display name,
// initials and avatar are derived from the players here, in ONE place.
export function useTimelineModels() {
    const playerName = (p) =>
        `${p?.firstName || ''} ${p?.lastName || ''}`.trim();

    const initialsFromName = (name) => {
        const parts = (name || '').trim().split(/\s+/).filter(Boolean);
        if (!parts.length) return '?';
        if (parts.length === 1) return parts[0][0].toUpperCase();
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    };

    const playerInitials = (p) => initialsFromName(playerName(p));

    // Named teams keep their name; player-based teams derive a display name from
    // the players: single → full name, two → "A + B" (sorted), more → "A + N".
    const teamName = (team) => {
        if (team?.name) return team.name;
        const players = team?.players || [];
        if (!players.length) return 'TBC';
        if (players.length === 1) return playerName(players[0]);
        const ordered = [...players].sort((a, b) =>
            playerName(a).toLowerCase().localeCompare(playerName(b).toLowerCase()));
        if (ordered.length === 2) {
            return `${playerName(ordered[0])} + ${playerName(ordered[1])}`;
        }
        return `${playerName(ordered[0])} + ${ordered.length - 1}`;
    };

    const teamInitials = (team) => {
        if (team?.initials) return team.initials;
        return initialsFromName(teamName(team));
    };

    const teamAvatar = (team) =>
        team?.imageFileName ?? team?.players?.[0]?.imageFileName ?? null;

    return {playerName, playerInitials, teamName, teamInitials, teamAvatar};
}
